var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3GlassBreak(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.75 12h-20.5A9.24 9.24 0 0018 21.25v33.5A9.26 9.26 0 0027.25 64h20.5A9.26 9.26 0 0057 54.75v-33.5A9.26 9.26 0 0047.75 12zM31.1 60h-3.85A5.25 5.25 0 0122 54.75v-33.5c0-.515.077-1.028.23-1.52L33.61 27l-2.44 12.58L41 48.75 31.1 60zM53 54.75A5.25 5.25 0 0147.75 60H36.44l8.82-10H53v4.75zM53 46h-9l-8.44-7.84L38.06 25 24.8 16.62a5.06 5.06 0 012.45-.62h20.5A5.25 5.25 0 0153 21.25V46z",
    fill: "#040404"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Glass_break.c07a84b3.svg";
export { SvgE3GlassBreak as ReactComponent };